import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BarChart from './Charts/Barchart';
import PieChart from './Charts/PieChart';
import lang from './lang';
import './Analytics.css';

class Analytics extends Component {
    state = {
        name: null,
        dimensions: [],
        color: [],
        totalSold: 0,
        code: [],
        currentData: [],
        unpopular: []
    }

    componentDidMount() {
        let data = {
            name: {},
            dimensions: {},
            color: {},
            code: {},
            totalSold: 0,
            carving: {},
            // popular: this.props.sales.sort((a,b) => a.piecesForSale - b.piecesForSale).slice(0, 5)//get populat 5 items
        }
        // Get current month
        const today = new Date();
        const startMonth = new Date(today.getFullYear(), today.getMonth(), 1).getTime();
        const endMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getTime();
        // const startLastMonth = new Date(today.getFullYear(), today.getMonth() -1, 1).getTime();
        // const endLastMonth = new Date(today.getFullYear(), today.getMonth(), 0).getTime();

        this.props.sales.forEach(item => {
            if (item.updatedAt >= startMonth && item.updatedAt <= endMonth) {
                if (data.code[`'${item.code}'`]) {
                    data.code[`'${item.code}'`].sold += 1;
                    data.code[`'${item.code}'`].piecesSold += item.piecesForSale;
                } else {
                    data.code[`'${item.code}'`] = { name: item.code, sold: 1, piecesSold: item.piecesForSale, id: item.productId };
                }

                if (data.color[`'${item.color}'`]) {
                    data.color[`'${item.color}'`].sold += 1;
                    data.color[`'${item.color}'`].piecesSold += item.piecesForSale;
                } else {
                    data.color[`'${item.color}'`] = { name: item.color, sold: 1, piecesSold: item.piecesForSale, id: item.productId }
                }

                if (data.dimensions[`'${item.dimensions}'`]) {
                    data.dimensions[`'${item.dimensions}'`].sold += 1;
                    data.dimensions[`'${item.dimensions}'`].piecesSold += item.piecesForSale;
                } else {
                    data.dimensions[`'${item.dimensions}'`] = { name: item.dimensions, sold: 1, piecesSold: item.piecesForSale, id: item.productId }
                }
            } else {
                console.log('sorry')
            }

            data.totalSold += item.piecesForSale;

        });
        const codeToArr = Object.values(data.code).sort((a, b) => b.piecesSold - a.piecesSold);
        const colorToArr = Object.values(data.color).sort((a, b) => b.piecesSold - a.piecesSold);
        const dimensionsToArr = Object.values(data.dimensions).sort((a, b) => b.piecesSold - a.piecesSold);
        this.setState({
            code: codeToArr,
            dimensions: dimensionsToArr,
            color: colorToArr,
            totalSold: data.totalSold,
            unpopular: codeToArr.slice(-3)
        });
    }

    lastMonthHandler = (event, month, month2) => {
        event.preventDefault();

        let data = {
            name: {},
            dimensions: {},
            color: {},
            code: {},
            totalSold: 0,
            unpopular: {},
            // popular: this.props.sales.sort((a,b) => a.piecesForSale - b.piecesForSale).slice(0, 5)//get populat 5 items
        }
        // Get current month
        var today = new Date();
        var startMonth = new Date(today.getFullYear(), today.getMonth() - month, 1);
        var endMonth = new Date(today.getFullYear(), today.getMonth() + month2, 0);

        this.props.sales.forEach(item => {
            if (item.updatedAt >= startMonth && item.updatedAt <= endMonth) {
                if (data.code[`'${item.code}'`]) {
                    data.code[`'${item.code}'`].sold += 1;
                    data.code[`'${item.code}'`].piecesSold += item.piecesForSale;
                } else {
                    data.code[`'${item.code}'`] = { name: item.code, sold: 1, piecesSold: item.piecesForSale, id: item.productId };
                }

                if (data.color[`'${item.color}'`]) {
                    data.color[`'${item.color}'`].sold += 1;
                    data.color[`'${item.color}'`].piecesSold += item.piecesForSale;
                } else {
                    data.color[`'${item.color}'`] = { name: item.color, sold: 1, piecesSold: item.piecesForSale, id: item.productId }
                }

                if (data.dimensions[`'${item.dimensions}'`]) {
                    data.dimensions[`'${item.dimensions}'`].sold += 1;
                    data.dimensions[`'${item.dimensions}'`].piecesSold += item.piecesForSale;
                } else {
                    data.dimensions[`'${item.dimensions}'`] = { name: item.dimensions, sold: 1, piecesSold: item.piecesForSale, id: item.productId }
                }
                data.totalSold += item.piecesForSale;
            } else {
                console.log('sorry')
            }

        });
        const codeToArr = Object.values(data.code).sort((a, b) => b.piecesSold - a.piecesSold);
        const colorToArr = Object.values(data.color).sort((a, b) => b.piecesSold - a.piecesSold);
        const dimensionsToArr = Object.values(data.dimensions).sort((a, b) => b.piecesSold - a.piecesSold);
        this.setState({
            code: codeToArr,
            dimensions: dimensionsToArr,
            color: colorToArr,
            totalSold: data.totalSold,
            unpopular: codeToArr.slice(-3)
        });
    }

    render() {
        const { month, year, byName, byColor, byDimension, unPopular } = lang[this.props.user.lang || "en"];

        return (
            <div className="py-5" id="analytics-page">
                <button className="btn btn-primary btn-sm" onClick={(event) => this.lastMonthHandler(event, 0, 1)}>{month}</button>
                <button className="btn btn-primary btn-sm mx-2" onClick={(event) => this.lastMonthHandler(event, 3, 0)}>3 {month}</button>
                <button className="btn btn-primary btn-sm" onClick={(event) => this.lastMonthHandler(event, 6, 0)}>6 {month}</button>
                <button className="btn btn-primary btn-sm ml-2" onClick={(event) => this.lastMonthHandler(event, 12, 0)}>1 {year}</button>
                {this.state.totalSold > 0 ?
                    (
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="graph">
                                    <BarChart
                                        data={this.state.code.slice(0, 5)}
                                        key1="piecesSold"
                                        key2="sold"
                                        key1Color="#3f51b5"
                                        key2Color="#9c27b0"
                                        title={byName}
                                        labelName="Total pieces sold"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="graph">
                                    <BarChart
                                        data={this.state.color.slice(0, 5)}
                                        key1="piecesSold"
                                        key2="sold"
                                        key1Color="#3f51b5"
                                        key2Color="#9c27b0"
                                        title={byColor}
                                        labelName="Total pieces sold"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="graph">
                                    <PieChart
                                        data={this.state.dimensions.slice(0, 5)}
                                        title={byDimension}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="graph">
                                    <BarChart
                                        data={this.state.unpopular.slice(0, 5)}
                                        key1="piecesSold"
                                        key2="sold"
                                        key1Color="#3f51b5"
                                        key2Color="#9c27b0"
                                        title={unPopular}
                                        labelName="Total pieces sold"
                                    />
                                </div>
                            </div>
                        </div>
                    )
                    :
                    (
                        <div className="alert bg-warning mt-5 text-center">
                            <h3>No Sales for the current date</h3>
                        </div>
                    )
                }
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
        sales: state.sales.sales,
        user: state.user
    }
}

Analytics.propTypes = {
    sales: PropTypes.array.isRequired,
}

export default connect(mapStateToProps)(Analytics);